import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { verifyAccess } from '../api/authApi';
import LoadingSpinner from './ui/Loading';

const PageWrapper = ({ children, referer, accessLevel, nextPage }) => {
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(false);

  useEffect(() => {
    const checkAccess = async () => {
      setIsVerifying(true);
      try {
        const { isAllowed } = await verifyAccess(referer, nextPage);
        
        if (!isAllowed) {
          navigate('/');
        } 

      } catch (error) {
        console.error('Access verification failed:', error);
        navigate('/');
      } finally {
        setIsVerifying(false);
      }
    };

    if(accessLevel > 0) {
      checkAccess();
    }
  }, [accessLevel, navigate, referer]);

  if (isVerifying) {
    return <LoadingSpinner />;
  }

  return children;
};

export default PageWrapper;
